import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ShieldIcon, ArrowLeftIcon } from 'lucide-react';
import { PrivacyAccordion } from '../components/policies/PrivacyAccordion';
export function Privacy() {
  return <>
      <Helmet data-id="element-1916">
        <title data-id="element-1917">Privacy & Cookie Policy | Bright Pixxel Studio</title>
        <meta name="description" content="How Bright Pixxel Studio collects, uses and protects your personal data, fully GDPR-compliant. Read our clear, plain-English privacy commitment." data-id="element-1918" />
        <link rel="canonical" href="https://bright-pixxel.com/privacy" data-id="element-1919" />
        {/* Open Graph Meta Tags */}
        <meta property="og:locale" content="en_GB" data-id="element-1920" />
        <meta property="og:type" content="website" data-id="element-1921" />
        <meta property="og:title" content="Privacy & Cookie Policy | Bright Pixxel Studio" data-id="element-1922" />
        <meta property="og:description" content="How Bright Pixxel Studio collects, uses and protects your personal data, fully GDPR-compliant. Read our clear, plain-English privacy commitment." data-id="element-1923" />
        <meta property="og:url" content="https://bright-pixxel.com/privacy" data-id="element-1924" />
        <meta property="og:site_name" content="Bright Pixxel Studio" data-id="element-1925" />
        <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/qh74mEBb962nRk6qjvv9uT/Geometric_Logo_of_Bright_Pixxel_Studio.png" data-id="element-1926" />
        <meta property="og:image:width" content="1200" data-id="element-1927" />
        <meta property="og:image:height" content="630" data-id="element-1928" />
        <meta property="og:image:type" content="image/png" data-id="element-1929" />
        <meta property="og:image:alt" content="Bright Pixxel Studio - Privacy & Cookie Policy" data-id="element-1930" />
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-1931" />
        <meta name="twitter:title" content="Privacy & Cookie Policy | Bright Pixxel Studio" data-id="element-1932" />
        <meta name="twitter:description" content="How Bright Pixxel Studio collects, uses and protects your personal data, fully GDPR-compliant. Read our clear, plain-English privacy commitment." data-id="element-1933" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/qh74mEBb962nRk6qjvv9uT/Geometric_Logo_of_Bright_Pixxel_Studio.png" data-id="element-1934" />
        <meta name="twitter:image:alt" content="Bright Pixxel Studio - Privacy & Cookie Policy" data-id="element-1935" />
      </Helmet>
      {/* Hero Section */}
      <section className="pt-16 md:pt-24 pb-12 bg-[#F9FAFB] dark:bg-[#121212]" data-id="element-1936">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1937">
          <div className="max-w-4xl mx-auto" data-id="element-1938">
            <Link to="/policies" className="inline-flex items-center text-[#0C1B26] hover:underline mb-6" data-id="element-1939">
              <ArrowLeftIcon size={16} className="mr-1" data-id="element-1940" />
              Back to Policies
            </Link>
            <div className="flex items-center mb-6" data-id="element-1941">
              <div className="w-12 h-12 rounded-full bg-[#0C1B26]/10 dark:bg-[#0C1B26]/20 flex items-center justify-center mr-4" data-id="element-1942">
                <ShieldIcon size={24} className="text-[#0C1B26]" data-id="element-1943" />
              </div>
              <motion.h1 initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              duration: 0.5
            }} className="text-3xl md:text-4xl font-bold" data-id="element-1944">
                Privacy & Cookie Policy
              </motion.h1>
            </div>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="text-lg text-gray-600 dark:text-gray-300 mb-4" data-id="element-1945">
              Last Updated: May 1, 2023
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="text-lg text-gray-600 dark:text-gray-300" data-id="element-1946">
              This Privacy & Cookie Policy explains how Bright Pixxel Studio
              ("we", "us", "our") collects, uses, and protects your personal
              information when you use our website and services. We are
              committed to ensuring the privacy and security of your data in
              compliance with the General Data Protection Regulation (GDPR).
            </motion.p>
          </div>
        </div>
      </section>
      {/* Policy Content */}
      <section className="py-12 bg-white dark:bg-[#1E1E1E]" data-id="element-1947">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1948">
          <div className="max-w-4xl mx-auto" data-id="element-1949">
            <PrivacyAccordion data-id="element-1950" />
          </div>
        </div>
      </section>
    </>;
}